import range from "lodash/range";
export var SchemaVersion;
(function (SchemaVersion) {
    SchemaVersion[SchemaVersion["None"] = 0] = "None";
    SchemaVersion[SchemaVersion["AddSchemaVersionFieldToDocument"] = 1] = "AddSchemaVersionFieldToDocument";
    SchemaVersion[SchemaVersion["AddArchivedFieldToDocument"] = 2] = "AddArchivedFieldToDocument";
    SchemaVersion[SchemaVersion["AddDefaultAnonRoleToDocument"] = 3] = "AddDefaultAnonRoleToDocument";
    SchemaVersion[SchemaVersion["AddUserAccessListToDocument"] = 4] = "AddUserAccessListToDocument";
    SchemaVersion[SchemaVersion["MoveTerminalPositionOnCanvasFromPartToDoc"] = 5] = "MoveTerminalPositionOnCanvasFromPartToDoc";
    SchemaVersion[SchemaVersion["AddDocumentOwnerHandleField"] = 6] = "AddDocumentOwnerHandleField";
    SchemaVersion[SchemaVersion["MovePropertiesFromPartVersionToDoc"] = 7] = "MovePropertiesFromPartVersionToDoc";
    SchemaVersion[SchemaVersion["AddPreviewImageFieldToDocument"] = 8] = "AddPreviewImageFieldToDocument";
    SchemaVersion[SchemaVersion["RemoveIsPublishedFieldFromDocument"] = 9] = "RemoveIsPublishedFieldFromDocument";
    SchemaVersion[SchemaVersion["MoveAssetsFromPartVersionToDocument"] = 10] = "MoveAssetsFromPartVersionToDocument";
    SchemaVersion[SchemaVersion["AddUidToAssetAndProperty"] = 11] = "AddUidToAssetAndProperty";
    SchemaVersion[SchemaVersion["RelinkCorruptParentChildrenUids"] = 12] = "RelinkCorruptParentChildrenUids";
    SchemaVersion[SchemaVersion["AddLatestActionRecordUidToDocument"] = 13] = "AddLatestActionRecordUidToDocument";
    SchemaVersion[SchemaVersion["RecomputeStableSimulationHash"] = 14] = "RecomputeStableSimulationHash";
    SchemaVersion[SchemaVersion["AssignStablePortalAndGroundNetIds"] = 15] = "AssignStablePortalAndGroundNetIds";
    SchemaVersion[SchemaVersion["AddDocumentNetsFieldAndPopulate"] = 16] = "AddDocumentNetsFieldAndPopulate";
    SchemaVersion[SchemaVersion["AddHasAnonAccessToDocument"] = 17] = "AddHasAnonAccessToDocument";
    SchemaVersion[SchemaVersion["PurgeKeepoutsFromNets"] = 18] = "PurgeKeepoutsFromNets";
})(SchemaVersion || (SchemaVersion = {}));
export const migrationNames = Object.keys(SchemaVersion).filter((name) => isNaN(Number(name)));
/**
 * Type guard for schema versions
 *
 * Enums get a reverse mapping, so we have to filter out non-numeric-string indexes from the SchemaVersion object
 */
export function isSchemaVersion(version) {
    return typeof version === "number" && !isNaN(version) && Object.values(SchemaVersion).includes(version);
}
/**
 * Type guard for migration names
 *
 * Enums get a reverse mapping, so we have to filter out numeric string indexes from the SchemaVersion object
 */
export function isMigrationName(name) {
    return typeof name === "string" && name in SchemaVersion && isNaN(Number(name));
}
/**
 * Given a document (with metadata - the IDocument interface ensures this), returns the current schema version of the document
 */
export function currentSchemaVersion(document) {
    return document.metadata.schemaVersion !== undefined ? document.metadata.schemaVersion : 0;
}
/**
 * Given a document and a target version, returns the list of eligible migrations to apply
 *
 * Note for lodash range: does include start, does not include end, and we must specify step (or it'll use -1 automatically in some cases)
 */
export function eligibleSchemaVersionsToApply(document, targetSchemaVersion) {
    return range(currentSchemaVersion(document) + 1, targetSchemaVersion + 1, 1);
}
//# sourceMappingURL=migration.js.map